import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddVmPool, TemplatesList } from 'src/app/core/models/node';
import { HeaderService } from 'src/app/core/services/header.service';
import { NodeService } from 'src/app/core/services/node.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { Node } from 'src/app/core/models/node';
import { ConfigEntityService } from '../../../../core/services/config-entity.service';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-add-node-from-template',
  templateUrl: './add-node-from-template.component.html',
  styleUrls: ['./add-node-from-template.component.scss']
})
export class AddNodeFromTemplateComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<AddNodeFromTemplateComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { depName: string; cloudType: string; nodeList: Node[] },
    public nodeService: NodeService,
    public depService: DeploymentService,
    public configService: ConfigEntityService,
    private _spinner: NgxSpinnerService,
    private _headerService: HeaderService,
    private _snackBar: MatSnackBar) { }

  deployments: string[] = !this.data.depName ? this._headerService.getQuickAccessDeploymentNames() : [this.data.depName];
  addNodeForm: UntypedFormGroup;
  depName: string = this.data.depName ? this.data.depName : null;
  cloudType: string = this.data.cloudType;
  gatewayNames: string[] = [];
  isFormSubmitted;
  showSkipDeploymentCheckbox: boolean = false;
  allvmpools: string[] = [];
  templateList: TemplatesList[] = [];

  ngOnInit(): void {
    this.addNodeForm = new UntypedFormGroup({
      poolname: new UntypedFormControl(null, [Validators.required]),
      template: new UntypedFormControl(null, [Validators.required]),
      numofnodes: new UntypedFormControl(1, [Validators.required, Validators.pattern('^[1-9][0-9]*$')])
    })
    this.getConnectorType(this.data.depName);
  }

  onClose() {
    this.dialog.close(false)
  }

  onSubmit(form) {
    if (!form.valid) {
      this.addNodeForm.markAllAsTouched();
      return;
    }
    let poolname: string = form.value.poolname;
    if (this.allvmpools.includes(poolname.toLowerCase())) {
      this._snackBar.open("Node Name Already Exists. Please Enter Unique Node Name, including Lowercase and Uppercase Letters.", "OK", {
        duration: 5000
      })
      return;
    }

    this.isFormSubmitted = true;
    let nodeData: AddVmPool = {
      PoolName: form.value.poolname,
      DeploymentName: this.data.depName,
      NumberOfNodes: form.value.numofnodes,
      TemplateName: form.value.template
    }

    this._spinner.show("addNode");
    this.nodeService.addNodeFromTemplate(nodeData, this.data.depName)
      .pipe(tap(d => this._spinner.show("addNode")))
      .subscribe({
        next: (data: any) => {
          this._spinner.hide("addNode")
          this._snackBar.open(data.actionMessage, "OK", {
            duration: 5000
          })
          this.dialog.close(true)
        }, error: (err) => {
          this._spinner.hide("addNode")
          this._snackBar.open(err.error.actionMessage, "OK", {
            duration: 5000
          })
          this.isFormSubmitted = false;
          this.dialog.close()
        }
      })
  }

  getConnectorType(depName) {
    this._spinner.show("addNode");
    this.nodeService.getConnectorType(depName).subscribe({
      next: (data: any) => {
        this._spinner.hide("addNode");
        if (data) {

          if (data?.templatesLists) {
            this.templateList = <TemplatesList[]>JSON.parse(JSON.stringify(data?.templatesLists))
            if (this.templateList) {
              this.addNodeForm.controls["template"].setValue(this.templateList[0]);
            }
            else {
              this._snackBar.open("No templates available to create nodes", "OK", {
                duration: 5000
              })
              this.isFormSubmitted = false;
              this.dialog.close()
            }
          }
          else {
            this._snackBar.open("No templates available to create nodes", "OK", {
              duration: 5000
            })
            this.isFormSubmitted = false;
            this.dialog.close()
          }

          if (data?.vmpools) {
            this.allvmpools = JSON.parse(JSON.stringify(data?.vmpools))
          }
        }
        this._spinner.hide("addNode");
      },
      error: (err) => {
        this._spinner.hide("addNode");
      }
    })
  }
}
